/**
 * App Light Theme
 */
import { createTheme } from '@mui/material/styles';
import AppConfig from 'Constants/AppConfig';
import { appTypography } from './typography';

const theme = createTheme({
    palette: {
        primary: {
            main: AppConfig.themeColors.secondary
        },
        secondary: {
            main: AppConfig.themeColors.primary
        }
    },
    typography: appTypography,
});

export default theme;